import { FC, HTMLAttributes } from "react";
import { _ } from "../utils/helpers";
import { FALLBACK_IMAGE } from "../utils/symbols";

interface SafeImageProps extends HTMLAttributes<HTMLImageElement> {
    src: string | null
    alt?: string
    className?: string
}

export const SafeImage: FC<SafeImageProps> = ({className, src, alt, ...props}) => {
    return (
        <img className={`img safe-image ${className}`} src={src || require(`../resources/img/${FALLBACK_IMAGE}`)} alt={alt} {...props} onError={(e) => {
            e.currentTarget.src = require(`../resources/img/${FALLBACK_IMAGE}`)
            e.currentTarget.classList.add('img-error')
        }}/>
    )
}